<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="80"
        transition="scale-transition"
        left
        offset-y
        min-width="300"
        class="field"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="appointmentDateTime"
                class="appointment-datetime"
                :label="label"
                readonly
                hide-details
                :rules="!readOnly ? rules: []"
                @click:clear="() => {
                    appointmentDate = null
                    appointmentTime = null }"
                v-bind="attrs"
                v-on="on"
            >
                <template v-slot:prepend-inner>
                    <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-calendar</v-icon>
                </template>
            </v-text-field>
        </template>
        <v-date-picker
            v-model="appointmentDate"
            :min="getGreekDate(new Date())"
            color="#0047AB"
            :disabled="readOnly"
            locale="el"
            @change="onChange"
        ></v-date-picker>
        <v-time-picker
            v-model="appointmentTime"
            color="#0047AB"
            format="24hr"
            :readonly="readOnly"
            scrollable
            :disabled="readOnly"
            @input="onChange"
        ></v-time-picker>
    </v-menu>
</template>
<script>
    import momentTimezone from 'moment-timezone'

    export default {
        props: {
            value: {
                type: String,
                default: () => { return ' ' },
                required: false
            },
            readOnly: {
                type: Boolean,
                required: true
            },
            label: {
                type: String,
                required: false,
                default: () => { return 'Ημ/νία & Ώρα Ραντεβού' }
            }
        },
        computed: {
            appointmentDateTime() {
                if (this.appointmentDate === 'Invalid date' || this.appointmentTime === 'Invalid date') {
                    return null
                }
                return (this.appointmentDate ? this.appointmentDate : '') + (this.appointmentTime ? ' ' + this.appointmentTime : '')
            },
            theming() {
                return this.$store.getters.getTheming || {}
            }
        },
        watch: {
            value: {
                handler(newVal, oldVal) {
                    if (newVal) {
                        this.appointmentDate = this.getGreekDate(newVal)
                        this.appointmentTime = this.getGreekTime(newVal)
                    }
                },
                immediate: true
            }
        },
        data() {
            return {
                menu: false,
                appointmentDate: null,
                appointmentTime: null,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ]
            }
        },
        methods: {
            getGreekDate(utcDateTime) {
                return momentTimezone(utcDateTime).utc().tz('Europe/Athens').format('YYYY-MM-DD').toString()
            },
            getGreekTime(utcDateTime) {
                return momentTimezone(utcDateTime).utc().tz('Europe/Athens').format('HH:mm').toString()
            },
            onChange() {
                if (this.appointmentDate && this.appointmentTime) {
                    this.$emit('onSelect', momentTimezone(this.appointmentDateTime).tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString())
                }
            }
        }
    }
</script>
<style scoped>
.appointment-datetime {
    min-width: 280px;
    max-width: 20%;
    padding: 1rem;
}
</style>
